<template>
  <section id="app-banner">
    <EmailNotVerifiedBanner v-if="canShowEmailBanner && !isEmailVerified" />
    <UserImpersonationBanner v-if="canShowUserImpersonationBanner" />
    <MaintenanceNoticeBanner />
  </section>
</template>

<script>
import EmailNotVerifiedBanner from '/@/modules/core/app/components/EmailNotVerifiedBanner.vue';
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import { AuthUserRoute } from '/@/modules/auth/routes/auth.routes';
import UserImpersonationBanner from '/@/modules/core/app/components/UserImpersonationBanner.vue';
import { HasCurrentEstateMixin } from '/@/modules/core/app/mixins/HasCurrentEstateMixin';
import { ShowReferralModalMixin } from '/@/modules/platformreferral/mixins/ShowReferralModalMixin';
import { CanReferMixin } from '/@/modules/platformreferral/mixins/CanReferMixin';
import MaintenanceNoticeBanner from '@/modules/core/app/components/MaintenanceNoticeBanner.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'AppBanner',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin, ShowReferralModalMixin, CanReferMixin],
  components: {
    UserImpersonationBanner,
    EmailNotVerifiedBanner,
    MaintenanceNoticeBanner
  },
  static: {
    excludedRouteNames: [AuthUserRoute.PROFILE.name]
  },
  computed: {
    isEmailVerified() {
      return !!this.authUser?.emailVerifiedAt;
    },
    canShowEmailBanner() {
      return !this.excludedRouteNames.includes(this.$route.name);
    },
    canShowUserImpersonationBanner() {
      return this.authUser?.isImpersonated;
    }
  }
};
</script>
